/**
 * Eine Taste im Fliesstext.
 *
 * Sie steht in der Fusszeile der Befehlspalette, in der Kurzuebersicht der
 * Tastenkuerzel und neben Schaltflaechen, die eines haben.
 *
 * **Das Kuerzel steht neben der Beschriftung, nie an ihrer Stelle.** Eine
 * Schaltflaeche, die nur "⌘K" heisst, ist auf einer Tastatur ohne diese
 * Taste unbeschriftet -- und fuer ein vorlesendes Programm ein Zeichen ohne
 * Namen.
 *
 * Welche Taste auf diesem Rechner die Zusatztaste ist, steht in
 * ``lib/keyboard.ts``.
 */
export function Kbd({ children }: { children: string }) {
  return <kbd className="kbd">{children}</kbd>;
}
